<div class="single-column">
  <ng-container *ngFor="let block of blocks">
    <tyt-content-block
      *ngIf="!block.hidden"
      [block]="block"
      [class.floats-left]="block.float === 'left'"
      [class.floats-right]="block.float === 'right'"
      ></tyt-content-block>
  </ng-container>
</div>

<ng-container *ngIf="secondaryBlocks.length > 0">
  <div class="multi-column">
    <div class="primary-column">
      <ng-container *ngFor="let block of primaryBlocks">
        <tyt-content-block
          *ngIf="!block.hidden"
          [block]="block"
          [class.floats-left]="block.float === 'left'"
          [class.floats-right]="block.float === 'right'"
          ></tyt-content-block>
      </ng-container>
    </div>
    <div class="secondary-column">
      <ng-container *ngFor="let block of secondaryBlocks">
        <tyt-content-block
          *ngIf="!block.hidden"
          [block]="block"
          [class.floats-left]="block.float === 'left'"
          [class.floats-right]="block.float === 'right'"
          ></tyt-content-block>
      </ng-container>
    </div>
  </div>
</ng-container>